export enum TranslationType {
  INTERNAL,
  EXTERNAL,
  RAW_TEXT,
}

interface ExternalTranslation {
  type: TranslationType.EXTERNAL;
  value: string;
}

interface RawTranslation {
  type: TranslationType.RAW_TEXT;
  value: string;
}

interface InternalTranslation {
  type: TranslationType.INTERNAL;
  value: string;
  params?: Dict<string | number>;
}

export type TranslationModel = RawTranslation | InternalTranslation | ExternalTranslation;
